import React, { forwardRef, useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { GridRow } from '@mui/x-data-grid';
import FolioLink from '@/components/FolioLink';
import { useInstantSearchDataGridContext } from '@/components/tables/InstantSearchDataGrid';
import {
	getSearchRecordNavigateOptions,
	getSearchRecordPath,
} from '@/components/tables/InstantSearchDataGrid/data';

const LinkedGridRow = forwardRef(function LinkedGridRow(props, ref) {
	const { row } = props;
	const [rowEl, setRowEl] = useState(null);
	const { enableRowClick, onRowClick: customOnRowClick, setHoveredRowId } =
		useInstantSearchDataGridContext();
	const path =
		enableRowClick && !customOnRowClick && !row?.fileMigrationInProgress
			? getSearchRecordPath(row)
			: null;
	const linkState = getSearchRecordNavigateOptions(row)?.state;

	const handleRef = useCallback(
		(node) => {
			setRowEl((current) => (current === node ? current : node));
			if (typeof ref === 'function') {
				ref(node);
			} else if (ref) {
				ref.current = node;
			}
		},
		[ref],
	);

	return (
		<>
			<GridRow ref={handleRef} {...props} />
			{path &&
				rowEl &&
				createPortal(
					<FolioLink
						to={path}
						state={linkState}
						stopPropagation
						tabIndex={-1}
						aria-hidden
						className='row-link-overlay'
						onMouseEnter={() => setHoveredRowId(row.id)}
						onMouseLeave={(event) => {
							if (
								event.relatedTarget instanceof Node &&
								rowEl.contains(event.relatedTarget)
							) {
								return;
							}
							setHoveredRowId(null);
						}}
						sx={{
							display: 'block',
							position: 'absolute',
							inset: 0,
							zIndex: 1,
						}}
					/>,
					rowEl,
				)}
		</>
	);
});

LinkedGridRow.displayName = 'LinkedGridRow';

export default LinkedGridRow;
